import { PodReviewMessageItemType, PodReviewMessageTranslationItemType } from '../pages/delivery/graphql/types/DeliveryTaskOrderType';
import i18n from '../i18n';

/**
 * 从POD审核消息项的翻译列表中获取当前语言对应的翻译
 *
 * @param translateFailureOtherReason 翻译列表
 * @returns 当前语言对应的翻译文本，如果没有则返回 null
 */
export function getPodReviewMessageTranslation(
    translateFailureOtherReason: PodReviewMessageTranslationItemType[] | null | undefined
): string | null {
    if (!translateFailureOtherReason || translateFailureOtherReason.length === 0) {
        return null;
    }

    const currentLanguage = i18n.language || 'en';
    const language = (currentLanguage || '').toLowerCase();
    const baseLanguage = language.split('-')[0];
    const preferredLanguages = Array.from(
        new Set([language, baseLanguage].filter(Boolean))
    );

    const matchedTranslation = translateFailureOtherReason.find(translation =>
        preferredLanguages.includes((translation.lang || '').toLowerCase())
    );

    return matchedTranslation?.translateFailureOtherReason || null;
}

/**
 * 获取翻译后的POD审核消息列表（字符串数组）
 *
 * 逻辑：
 * 1. 遍历 podReviewMessage 数组
 * 2. 对于已知错误类型，直接返回 failureOtherReason
 * 3. 对于其他原因，从 translateFailureOtherReason 中查找对应语言的翻译
 * 4. 如果有翻译则使用翻译，否则使用原文
 *
 * @param podReviewMessage POD审核消息项列表
 * @returns 翻译后的POD审核消息列表（字符串数组）
 */
export function getTranslatedPodReviewMessage(
    podReviewMessage: PodReviewMessageItemType[] | null | undefined
): string[] | null {
    if (!podReviewMessage || podReviewMessage.length === 0) {
        return null;
    }

    const knownErrorTypes = ['NO_LABEL_PHOTO', 'WRONG_TRK', 'NO_HOUSE_APT', 'WRONG_HOUSE_APT'];

    return podReviewMessage.map(item => {
        // 防御性检查：确保 failureOtherReason 存在
        if (!item.failureOtherReason) {
            return '';
        }
        
        if (knownErrorTypes.includes(item.failureOtherReason)) {
            // 已知错误类型：直接返回原文
            return item.failureOtherReason;
        } else {
            // 其他原因：查找对应语言的翻译
            const translated = getPodReviewMessageTranslation(
                item.translateFailureOtherReason
            );
            // 如果没有翻译，使用原文（兜底机制）
            return translated || item.failureOtherReason;
        }
    });
}

